import {zipAndEmailTestTreatment, zipOnlyTestTreatment} from './zipcodeentry.constants';
import {ZipSplitTest} from '@components/Sku/ZipCodeEntry/ZipCodeEntry';

export const getTos = (splitTreatment: string) => {
  let tos = 'By signing and clicking Get a Price, I agree to Hellotech’s';
  if (splitTreatment === zipOnlyTestTreatment) {
    tos = 'By entering ZIP code and clicking Get a Price, I agree to Hellotech’s';
  }
  return tos;
};

export const shouldShowZipCodeTest = (
  isZipCodeTestCookiePresent: boolean,
  customerZipSplitTreatment: ZipSplitTest,
  isUserLoggedIn: boolean,
  isPartner: boolean = false,
) => {
  const showZipTreatmentFlow = customerZipSplitTreatment === zipOnlyTestTreatment;
  const showZipAndEmailTreatmentFlow = customerZipSplitTreatment === zipAndEmailTestTreatment;
  const showSplitTreatment = showZipTreatmentFlow || showZipAndEmailTreatmentFlow;
  const showZipCodeTest = showSplitTreatment && !isZipCodeTestCookiePresent && !isUserLoggedIn && !isPartner;

  return showZipCodeTest;
};
